import { Api } from 'src/api';
import { RequestsCountsResponse } from 'src/api/services/RequestClient';
import { authQueries } from 'src/api/queries/queries';
import { defaultOptions, UseQueryOptionsObject } from '../queries.utils';
import { useMakeQuery } from '../useMakeQuery';
import { ApiQueryObject } from 'src/lib/services/api-query-params';

/** Stale time for company request counts - 30 seconds per api-data-fetching.md */
export const COMPANY_COUNTS_STALE_TIME = 30 * 1000;

const useCompanyRequestsCountsQuery = (
  companyId: string,
  params?: ApiQueryObject,
  options?: UseQueryOptionsObject<RequestsCountsResponse>,
) => {
  return useMakeQuery<RequestsCountsResponse>(
    [authQueries.requestCounts, companyId, params],
    () => Api.request.fetchCompanyRequestsCounts(companyId, params),
    {
      staleTime: COMPANY_COUNTS_STALE_TIME,
      ...defaultOptions({
        auth: true,
        ...(options ?? {}),
      }),
    },
  );
};

export { useCompanyRequestsCountsQuery };
